module.exports = __webpack_public_path__ + "static/img/BLAKE-KELLY.35d17fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLAKE-KELLY.jpg
// module id = wF1n
// module chunks = 0